import * as React from "react";
import { Users } from "./UsersPage";
import { UsersProvider } from "./context/UsersContext";

type Props = {};

const UsersPage = (props: Props) => {
	return (
		<UsersProvider>
			<Users />
		</UsersProvider>
	);
};

export default UsersPage;
